import * as types from "./types";

export const hideSearchBar = () => ({
    type: types.HIDE_SEARCH_BAR,
    isVisible: false
});

export const showSearchBar = () => ({
    type: types.SHOW_SEARCH_BAR,
    isVisible: true
});